import { Injectable } from '@angular/core';

import { mergeMap, Observable, of } from 'rxjs';

import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as UserActions from './user.actions';
import { RouterActions } from '@store/router';

@Injectable({ providedIn: 'root' })
export class UserEffects {
  constructor(private actions$: Actions) {}

  login$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.login),
      mergeMap(({ redirectUrl }) => of(RouterActions.navigate({ url: redirectUrl || '/' })))
    )
  );
}
